/**
 * apps/web :: pass :: screens/tripLifecycle.routes
 *
 * Route descriptors for the trip-lifecycle surface (ROADS-569 W1.C3/C4):
 * the hub plus the three phase checklists, mounted under `/pass/*`.
 */
import type { PassRouteDescriptor } from "../routeDescriptor";
import TripLifecycleHub from "./TripLifecycleHub";
import PreTripChecklist from "./PreTripChecklist";
import OnTripChecklist from "./OnTripChecklist";
import PostTripChecklist from "./PostTripChecklist";

export const tripLifecycleRoutes: PassRouteDescriptor[] = [
  { path: "plan", element: <TripLifecycleHub /> },
  { path: "pre-trip", element: <PreTripChecklist /> },
  { path: "on-trip", element: <OnTripChecklist /> },
  { path: "post-trip", element: <PostTripChecklist /> },
];
